import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { data } from '../composables/useData'
import { method } from '../composables/useMethod'
import { useRouter } from 'vue-router'
import { ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SignupPage',
  setup(__props) {

const router = useRouter();

const show1 = ref(false)


return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { justify: "center" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { lg: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode("新規登録")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_form, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_text_field, {
                            modelValue: _unref(data).loginUser.name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).loginUser.name) = $event)),
                            label: "名前",
                            rules: [v => !!v || '名前を入力してください']
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: _unref(data).loginUser.email,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(data).loginUser.email) = $event)),
                            rules: [v => !!v || 'メールアドレスを入力してください', v => /.+@.+\..+/.test(v) || '有効なメールアドレスを入力してください']
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_v_text_field, {
                            modelValue: _unref(data).loginUser.password,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(data).loginUser.password) = $event)),
                            label: "パスワード",
                            "append-inner-icon": show1.value ? 'mdi-eye' : 'mdi-eye-off',
                            type: show1.value ? 'text' : 'password',
                            "onClick:appendInner": _cache[3] || (_cache[3] = ($event: any) => (show1.value = !show1.value)),
                            rules: [v => v.length >= 6 || '最低6文字が必要です']
                          }, null, 8, ["modelValue", "append-inner-icon", "type", "rules"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_actions, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(method).signUp.submit(_unref(router)))),
                        disabled: !(_unref(data).loginUser.name && _unref(data).loginUser.email && _unref(data).loginUser.password && _unref(data).loginUser.password.length >= 6) || _unref(data).overlay
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("登録する ")
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createVNode(_component_v_btn, {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(method).login(_unref(router))))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("ログインする")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(method).google.getGoogleAnalyticsAccounts()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("アカウントリスト取得")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_unref(method).google.getGoogleAnalyticsProperties()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("プロパティリスト取得")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_btn, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(method).google.getGAData(_unref(router),true)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("GA4データ取得（テスト用 1年分）")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})